import Redirect from './redirect'

export default Redirect
